@let apiResponse = data();
<div class="flex flex-col h-full">
  <div>
    <h1>Dokumenter</h1>
  </div>
  <p-tabs
    [(value)]="dokService.activeTab"
    class="flex-1 border-1 overflow-hidden"
  >
    <p-tablist>
      <p-tab value="search"><i class="pi pi-search"></i> Søgning</p-tab>
      @if (apiResponse && apiResponse.data.length > 0) {
      <p-tab value="result"
        ><i class="pi pi-list"></i> Resultat
      </p-tab>
      } @if (dokService.selectedDokument()) {
      <p-tab value="detail"><i class="pi pi-file"></i> Detaljer</p-tab>
      }
    </p-tablist>
    <p-tabpanels class="overflow-hidden">
      <p-tabpanel value="search">
        <app-dokument-search />
      </p-tabpanel>
      <p-tabpanel value="result">
        <app-dokument-result />
      </p-tabpanel>
      <p-tabpanel value="detail">
        <app-dokument-detail />
      </p-tabpanel>
    </p-tabpanels>
  </p-tabs>
</div>
